<template>
  <span>
    <v-row dense class="mt-2">
      <v-col cols="12" md="5">
        <dashboard-isfp-psfp-tabela-detalhamento
          :tabelaServicos="tabelaServicosComFiltro"
          :codigoServicoSelecionado="codigoServicoSelecionado"
          :loading="loadings.tabela"
          :ano="ano"
          @servicoSelecionado="onServicoSelecionado"
        />
      </v-col>

      <v-col cols="12" md="7">
        <dashboard-isfp-psfp-kpis-detalhamento
          :servicoSelecionado="servicoSelecionadoLocal"
          :competencia="competencia"
          :loading="loadings.servico"
        />
      </v-col>
    </v-row>

    <v-row dense class="mt-2">
      <v-col cols="12">
        <dashboard-isfp-psfp-dispersao-detalhamento
          :dispersao="dispersaoComFiltro"
          :loading="loadings.dispersao"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script>
import DashboardIsfpPsfpService from "@/services/DashboardIsfpPsfpService";
import { mapActions } from "vuex";
import dayjs from "dayjs";

export default {
  name: "DashboardIsfpPsfpDetalhamento",
  components: {
    DashboardIsfpPsfpTabelaDetalhamento: () =>
      import(
        "@/components/dashboardIsfpPsfp/DashboardIsfpPsfpTabelaDetalhamento.vue"
      ),
    DashboardIsfpPsfpKpisDetalhamento: () =>
      import(
        "@/components/dashboardIsfpPsfp/DashboardIsfpPsfpKpisDetalhamento.vue"
      ),
    DashboardIsfpPsfpDispersaoDetalhamento: () =>
      import(
        "@/components/dashboardIsfpPsfp/DashboardIsfpPsfpDispersaoDetalhamento.vue"
      ),
  },
  props: {
    competencia: { type: String, required: true },
    modoPeriodo: { type: String, default: "12m" },
    ano: { type: Number, default: null },
    activatedTab: { type: Number, required: true },
    servicosSelecionados: { type: Array, default: () => [] },
    categoriasServicosSelecionadas: { type: Array, default: () => [] },
    indicesSelecionados: { type: Array, default: () => [] },
    codigoPreSelecionado: { type: Number, default: null },
  },
  data: () => ({
    tabelaServicos: [],
    servicoSelecionadoLocal: null,
    dispersao: [],
    codigoServicoSelecionado: 0,
    servicosCache: {},
    debounceTimer: null,
    loadings: {
      tabela: false,
      servico: false,
      dispersao: false,
    },
  }),
  computed: {
    tabelaServicosComFiltro() {
      if (!this.indicesSelecionados.length) return this.tabelaServicos;
      return this.tabelaServicos.filter((item) =>
        this.indicesSelecionados.includes(item.indice_categoria),
      );
    },
    dispersaoComFiltro() {
      if (!this.indicesSelecionados.length) return this.dispersao;
      return this.dispersao.filter((item) =>
        this.indicesSelecionados.includes(item.indice_categoria),
      );
    },
    parametrosFiltro() {
      return {
        competencia: this.competencia,
        modoPeriodo: this.modoPeriodo,
        ano: this.ano,
        servicosSelecionados: this.servicosSelecionados,
        categoriasServicosSelecionadas: this.categoriasServicosSelecionadas,
      };
    },
  },
  methods: {
    ...mapActions("parametrosDashboardIsfpPsfp", ["setServicoSelecionado"]),
    getDadosDebounced() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.getDados();
      }, 50);
    },
    getDados() {
      if (this.activatedTab !== 2) return;
      if (!this.servicosSelecionados.length) return;

      const competenciaNormalizada = this.competencia
        ? dayjs(`${this.competencia}-01`)
            .endOf("month")
            .format("YYYY-MM-DD")
        : null;

      if (!competenciaNormalizada) return;

      this.codigoServicoSelecionado = 0;
      this.servicoSelecionadoLocal = null;
      this.servicosCache = {};

      this.loadings.tabela = true;
      this.loadings.dispersao = true;
      this.$emit("updateLoadingDados", true);

      DashboardIsfpPsfpService.getDadosTela3DetalhamentoResumo(
        competenciaNormalizada,
        this.modoPeriodo,
        this.ano,
        this.servicosSelecionados,
      )
        .then((res) => {
          this.tabelaServicos = res.tabela_servicos;
          this.dispersao = res.dispersao;

          if (this.codigoPreSelecionado) {
            this.carregarServico(this.codigoPreSelecionado);
          }
        })
        .catch(() => {
          this.$toast.error("Erro ao recuperar dados.", "", {
            position: "topRight",
          });
        })
        .finally(() => {
          this.loadings.tabela = false;
          this.loadings.dispersao = false;
          this.$emit("updateLoadingDados", false);
        });
    },
    carregarServico(codigoServico) {
      if (!codigoServico) {
        this.servicoSelecionadoLocal = null;
        return;
      }

      if (this.servicosCache[codigoServico]) {
        this.servicoSelecionadoLocal = this.servicosCache[codigoServico];
        return;
      }

      const competenciaNormalizada = this.competencia
        ? dayjs(`${this.competencia}-01`)
            .endOf("month")
            .format("YYYY-MM-DD")
        : null;

      if (!competenciaNormalizada) return;

      this.loadings.servico = true;

      DashboardIsfpPsfpService.getDadosTela3DetalhamentoServico(
        competenciaNormalizada,
        this.modoPeriodo,
        this.ano,
        this.servicosSelecionados,
        codigoServico,
      )
        .then((res) => {
          this.servicoSelecionadoLocal = res.servico_selecionado || null;
          if (this.servicoSelecionadoLocal) {
            this.servicosCache[codigoServico] = this.servicoSelecionadoLocal;
          }
        })
        .catch(() => {
          this.$toast.error("Erro ao recuperar dados do serviço.", "", {
            position: "topRight",
          });
        })
        .finally(() => {
          this.loadings.servico = false;
        });
    },
    onServicoSelecionado(codigoServico) {
      this.codigoServicoSelecionado = codigoServico;
      this.carregarServico(codigoServico);
    },
  },
  watch: {
    activatedTab() {
      this.getDadosDebounced();
    },
    parametrosFiltro: {
      deep: true,
      handler(newVal) {
        if (!newVal.servicosSelecionados.length) return;
        this.getDadosDebounced();
      },
    },
  },
};
</script>
